import React from 'react';
import { Helmet } from 'react-helmet';
import HeroSection from './components/HeroSection';
import MatSuValley from './components/MatSuValley';
import Articles from './components/Articles';
import Podcast from './components/Podcast';
import Media from './components/Media';

const ResourcesPage = () => {
  return (
    <div className="overflow-hidden">
      <Helmet>
        <title>
          Resources | Pediatric Therapy Resources Wasilla Alaska | Guidepost
        </title>
        <meta
          name="description"
          content="Helpful resources for families in Wasilla, Alaska. Articles, podcasts, media, and community information about pediatric therapy, child development, and health."
        />
        <meta
          name="keywords"
          content="pediatric therapy resources Wasilla, child development resources Alaska, therapy articles, Mat-Su Valley resources"
        />
      </Helmet>
      <HeroSection />
      <MatSuValley />
      <Articles />
      <Podcast />
      <Media />
    </div>
  );
};

export default ResourcesPage;
